module.exports = __webpack_public_path__ + "img/functional-deficiency.714e3385.png";